<template>
  <v-dialog persistent width="320" style="min-width: 320px"  v-model="showPayVerifyDialog">
    <v-card style="width: 100%;height: 350px;position: relative">
      <!--顶部-->
      <div style="height: 70px;font-size: 24px;line-height: 70px;font-weight: 700;text-align: center">
        支付验证
        <span @click="closePayDialog" class="iconfontFamily" style="font-size: 15px;color: rgba(166, 166, 166, 1);position: absolute;right: 30px;cursor: pointer">&#xe60d;</span>
      </div>
      <v-divider style="background-color: rgba(229, 229, 229, 1)"></v-divider>
      <!--内容-->
      <div style="height: 200px">
        <div style="font-size: 18px;font-weight: 700;margin-left: 30px;padding-top: 30px;">
          请输入登录密码验证身份
        </div>
        <div style="width: 200px;height: 35px;margin: 35px auto 0 auto;border-radius: 3px" :style="{border:passwordMismatch?'2px solid rgba(255, 0, 0, 1)':'1px solid rgba(229, 229, 229, 1)'}">
          <input v-model="loginPassword" type="password"  placeholder="请输入登录密码" style="border: none;outline: none;height: 35px;padding-left: 10px">
          <div v-show="passwordMismatch" style="margin-top: 5px;color: rgba(255, 0, 0, 1);font-size: 14px"><span class="iconfontFamily">&#xe612;</span>&nbsp;密码有误，请重新输入</div>
        </div>
      </div>
      <v-divider style="background-color: rgba(229, 229, 229, 1)"></v-divider>
      <div style="width: 100%;">
        <div style="width: max-content;margin: 18px auto 0 auto;">
          <v-btn @click="verify" width="100" height="40" :color="loginPassword.length>0?'rgba(30, 64, 175, 1)':'rgba(30, 64, 175, 0.5)'" style="color: white;">
            继续下载
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PayVerify",
  data(){
    return{
      showPayVerifyDialog:false,
      loginPassword:'',
      passwordMismatch:false,
    }
  },
  props:{
    'downloadProduct':{
      type:Function
    }
  },
  methods:{
    closePayDialog(){
      this.showPayVerifyDialog = false
      this.loginPassword = ''
      this.passwordMismatch = false
    },
    verify(){
      if(this.loginPassword.length < 1){
        return
      }
      this.verifyMailPassword()
    },
    async verifyMailPassword() {
      this.passwordMismatch = false;
      if (this.loginPassword === "111111") {
        this.showPayVerifyDialog = false
        this.downloadProduct()
      }else{
        // this.passwordMismatch = true

        let resultData = await this.$axios.get('/userApi/creator/verifyPassword', {
          params: {'password': this.loginPassword}
        })
        if (resultData.data.code === 200) {
          this.showPayVerifyDialog = false
          this.downloadProduct()
        }else{
          this.passwordMismatch = true
        }


      }
      // let resultData = await this.$axios.get('/userApi/creator/verifyPassword', {
      //   params: {'password': this.loginPassword}
      // })
      // if (resultData.data.code === 200) {
      //   this.showPayVerifyDialog = false
      //   this.downloadProduct()
      // }else{
      //   this.passwordMismatch = true
      // }
    },
  },
}
</script>

<style scoped>
/*各浏览器提示文本样式*/
input::-webkit-input-placeholder { /* WebKit browsers */
  color: rgba(128, 128, 128, 1);
  font-size: 16px;
}
input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  color: rgba(128, 128, 128, 1);
  font-size: 16px;
}
input::-moz-placeholder { /* Mozilla Firefox 19+ */
  color: rgba(128, 128, 128, 1);
  font-size: 16px;
}
input:-ms-input-placeholder { /* Internet Explorer 10+ */
  color: rgba(128, 128, 128, 1);
  font-size: 16px;
}
</style>